// extracted by mini-css-extract-plugin
export var cardContainer = "_qv-0";
export var cardHeader = "_qv-2";
export var collapsedState = "_qv-3";
export var dragHandle = "_qv-5";
export var dragHandleIcon = "_qv-6";
export var dragging = "_qv-1";
export var titleArea = "_qv-4";